export default __webpack_public_path__ + "static/media/chart.7c4d9328.svg";